import { gql } from "@apollo/client";

import RunActionFieldsFragment from "components/Run/elements/ActionButtons/ActionFragment";

export const GET_VERSION_RUN = gql`
  query GetVersionRun($moduleId: ID!, $runId: ID!, $term: String!) {
    module(id: $moduleId) {
      id
      versionFind(term: $term) {
        id
        number
      }
      run(id: $runId) {
        ...RunActionFieldsFragment
        branch
        command
        canRetry
        retryBlocker
        isPrioritized
        createdAt
        comments {
          __typename
          body
          createdAt
          username
        }
        commit {
          authorLogin
          authorName
          hash
          timestamp
          url
        }
        needsApproval
        expectFailure
        expired
        isMostRecent
        reviews {
          id
          author
          decision
          note
          timestamp
        }
        planPoliciesOutcomes {
          id
          deny
          warn
          createdAt
        }
        policyReceipts {
          id
          createdAt
          policyName
          policyType
          policySlug
          outcome
          sampled
          sampleExpired
          flags
        }
        runtimeConfig {
          terraform {
            version
          }
        }
        title
        triggeredBy
        type
      }
    }
  }
  ${RunActionFieldsFragment}
`;
